import { TransformDate } from '../../../shared/decorators/transform-date.decorator';
import { ApiRequestFilters } from '../../../shared/types/api-request-filters';
import { VehicleAllocationEnum } from '../enums/vehicle-allocation.enum';
import { VehicleBodyTypeEnum } from '../enums/vehicle-body-type.enum';
import { VehicleDriveTrainTypeEnum } from '../enums/vehicle-drive-train-type.enum';
import { VehicleFuelTypeEnum } from '../enums/vehicle-fuel-type.enum';
import { VehiclePowerPlantTypeEnum } from '../enums/vehicle-power-plant-type.enum';
import { VehicleStatusEnum } from '../enums/vehicle-status.enum';
import { VehicleTransmissionTypeEnum } from '../enums/vehicle-transmission-type.enum';
import { VehicleTypeEnum } from '../enums/vehicle-type.enum';

/**
 * Vehicles filters
 */
export class VehiclesFilters extends ApiRequestFilters {
  /**
   * Available from date
   */
  @TransformDate()
  availableFrom?: Date;

  /**
   * Available to date
   */
  @TransformDate()
  availableTo?: Date;

  /**
   * Flag to include unavailable records in results
   */
  includeUnavailable?: boolean = true;

  /**
   * Vehicle body type values
   */
  bodyTypes?: VehicleBodyTypeEnum[];

  /**
   * Vehicle fuel type values
   */
  fuelTypes?: VehicleFuelTypeEnum[];

  /**
   * Vehicle exterior color id values
   */
  exteriorColors?: number[];

  /**
   * Vehicle interior color id values
   */
  interiorColors?: number[];

  /**
   * Vehicle drive train type values
   */
  driveTrainTypes?: VehicleDriveTrainTypeEnum[];

  /**
   * Vehicle transmission type values
   */
  transmissionTypes?: VehicleTransmissionTypeEnum[];

  /**
   * Vehicle power plant type values
   */
  powerPlantTypes?: VehiclePowerPlantTypeEnum[];

  /**
   * Vehicle allocation values
   */
  allocations?: VehicleAllocationEnum[];

  /**
   * Location id values
   */
  locations?: number[];

  /**
   * Supplier id values
   */
  suppliers?: number[];

  /**
   * Vehicle category id values
   */
  vehicleCategories?: number[];

  /**
   * Vehicle group id values (derived from the vehicle's category)
   */
  vehicleGroups?: number[];

  /**
   * Odometer value from
   */
  odometerValueFrom?: number;

  /**
   * Odometer value to
   */
  odometerValueTo?: number;

  /**
   * Status values
   */
  statuses?: VehicleStatusEnum[];

  /**
   * Type values
   */
  types?: VehicleTypeEnum[];

  /**
   * Tag id values
   */
  tags?: number[];
}
